module.exports = __webpack_public_path__ + "static/media/app-match.c53e1428.jpeg";